export default __webpack_public_path__ + "static/media/giide-illo-01.1ff2043a.jpg";